import { NavBar } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { AppSubNav } from "../AppSubNav";

const NavigationTime = () => {
  return (
    <AppSubNav>
      <NavBar.Item
        href={{ pathname: "/time-tracking/day" }}
      >{t`Time tracking`}</NavBar.Item>
    </AppSubNav>
  );
};

export default observer(NavigationTime);
